// extracted by mini-css-extract-plugin
export default {"container":"xJ-z","vocBtn":"yJ-z","disabled":"zJ-z"};